import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'ramda/src/isNil';
import length from 'ramda/src/length';
import RamdaType from 'ramda/src/type';
import values from 'ramda/src/values';
import Accordion from '@components/@core/Accordion';
import CheckIcon from '@components/@core/CheckIcon';

function Status(target, actual) {
    return (
        <div className="d-flex d-flex-1 ai-center">
            <div className="d-flex-5 d-flex-sm-2 dsl-b14 text-end">{target}</div>
            <div className="d-flex-1 dsl-b14 text-end">{actual}</div>
        </div>
    );
}

class HabitsDetail extends React.PureComponent {
    state = {
        habits: [],
        daily: [],
        weekly: [],
        monthly: [],
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.data !== prevState.habits) {
            let daily = [],
                weekly = [],
                monthly = [];
            if (RamdaType(nextProps.data) === 'Array') {
                nextProps.data.map((item) => {
                    if (item.data.schedule_interval === 'day') {
                        daily.push(item);
                    } else if (item.data.schedule_interval === 'week') {
                        weekly.push(item);
                    } else {
                        monthly.push(item);
                    }
                });
            } else if (RamdaType(nextProps.data) === 'Object') {
                daily = nextProps.data.day || [];
                weekly = nextProps.data.week || [];
                monthly = nextProps.data.month || [];
            }
            return {
                habits: nextProps.data,
                daily,
                weekly,
                monthly,
            };
        }

        return null;
    }

    render() {
        const { daily, weekly, monthly } = this.state;
        const { type, stats } = this.props;

        const dailyItems = isNil(stats.day.items) ? daily : values(stats.day.items);
        const weeklyItems = isNil(stats.week.items) ? weekly : values(stats.week.items);
        const monthlyItems = isNil(stats.month.items) ? monthly : values(stats.month.items);

        return (
            <div className="career-required-instances">
                {type === 'instance' && (
                    <div className="d-flex border-bottom">
                        <div className="d-flex-3 dsl-m12">Habits</div>
                        <div className="d-flex d-flex-1 ai-center">
                            <div className="d-flex-1 dsl-m12 text-end">Target</div>
                            <div className="d-flex-1 dsl-m12 text-end">Actual</div>
                        </div>
                    </div>
                )}
                <div className="habits">
                    <Accordion
                        size="regular"
                        type="secondary"
                        icon="far fa-circle"
                        className="habit-accordion w-100"
                        title={`Daily Habit Completion (${length(dailyItems)})`}
                        subTitle={type === 'instance' ? Status('60%', `${stats.day.completion || 0}%`) : null}
                    >
                        {dailyItems.map((item, index) => (
                            <div className="d-flex jc-between py-2" key={`dailyitem${index}`}>
                                <div className="d-flex">
                                    <CheckIcon size={26} checked={item.completion === 100} />
                                    <div>
                                        <p className="dsl-b16 mb-1">{item.name || item.data.name}</p>
                                        <p className="dsl-m12 mb-0">{`Completed: ${item.completion || 0}%`}</p>
                                    </div>
                                </div>
                                <div className="edit" />
                            </div>
                        ))}
                    </Accordion>
                    <Accordion
                        size="regular"
                        type="secondary"
                        icon="far fa-circle"
                        className="habit-accordion"
                        title={`Weekly Habit Completion (${length(weeklyItems)})`}
                        subTitle={type === 'instance' ? Status('60%', `${stats.week.completion || 0}%`) : null}
                    >
                        {weeklyItems.map((item, index) => (
                            <div className="d-flex jc-between py-2" key={`weeklyitem${index}`}>
                                <div className="d-flex">
                                    <CheckIcon size={26} checked={item.completion === 100} />
                                    <div>
                                        <p className="dsl-b16 mb-1">{item.name || item.data.name}</p>
                                        <p className="dsl-m12 mb-0">{`Completed: ${item.completion || 0}%`}</p>
                                    </div>
                                </div>
                                <div className="edit" />
                            </div>
                        ))}
                    </Accordion>
                    <Accordion
                        size="regular"
                        type="secondary"
                        icon="far fa-circle"
                        className="habit-accordion"
                        title={`Monthly Habit Completion (${length(monthlyItems)})`}
                        subTitle={type === 'instance' ? Status('60%', `${stats.month.completion || 0}%`) : null}
                    >
                        {monthlyItems.map((item, index) => (
                            <div className="d-flex jc-between py-2" key={`monthlyitem${index}`}>
                                <div className="d-flex">
                                    <CheckIcon size={26} checked={item.completion === 100} />
                                    <div>
                                        <p className="dsl-b16 mb-1">{item.name || item.data.name}</p>
                                        <p className="dsl-m12 mb-0">{`Completed: ${item.completion || 0}%`}</p>
                                    </div>
                                </div>
                                <div className="edit" />
                            </div>
                        ))}
                    </Accordion>
                </div>
            </div>
        );
    }
}

HabitsDetail.propTypes = {
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
    stats: PropTypes.shape({
        day: PropTypes.any,
        week: PropTypes.any,
        month: PropTypes.any,
    }),
    type: PropTypes.oneOf(['instance', 'template']),
};

HabitsDetail.defaultProps = {
    data: [],
    stats: {
        day: {},
        week: {},
        month: {},
    },
    type: 'instance',
};

export default HabitsDetail;
